// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2OlD3","Label":"Input_Label__xs8Ow","InputElement":"Input_InputElement__1dVIi","Invalid":"Input_Invalid__WvgeY"};